module.exports = __webpack_public_path__ + "static/media/independent.c9bae442.png";